let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eX2p2")).then(() => parcelRequire('283Hr'));